module.exports = __webpack_public_path__ + "img/card_hj@3x.4aadb0c9.png";